import AWS from 'aws-sdk';
import { InvocationRequest } from 'aws-sdk/clients/lambda';
import axios, { AxiosRequestConfig } from 'axios';
import { env, isLocal } from './environment';
import { getLoggerInstance } from './logger';

const logger = getLoggerInstance();

const lambda = new AWS.Lambda({ region: 'eu-west-1' });

interface IFireAndForgetParams {
  microService: MicroService;
  functionName: string;
  functionUrl: string;
  payload: any;
}
export async function fireAndForget({
  microService,
  functionName,
  functionUrl,
  payload,
}: IFireAndForgetParams) {
  const fullFunctionName = `${microService}-${env}-${functionName}`;
  if (isLocal) {
    const axiosOption: AxiosRequestConfig = {
      // because this is async, it can't be GET as we're not waiting for something to be fetched
      method: 'POST',
      url: functionUrl,
      data: payload,
    };
    logger.trace({ axiosOption }, 'lambda invoke local request');
    const { data: responseData } = await axios(axiosOption);
    logger.trace({ responseData }, 'lambda invoke local response');
  } else {
    const invokeParams: InvocationRequest = {
      FunctionName: fullFunctionName,
      InvocationType: 'Event',
      LogType: 'None',
      Payload: JSON.stringify({ body: JSON.stringify(payload) }),
    };
    logger.trace({ invokeParams }, 'lambda invoke aws request');
    const invokeResponse = await lambda.invoke(invokeParams).promise();
    logger.trace({ invokeResponse }, 'lambda invoke aws response');
  }
}

export enum MicroService {
  thirdParty = 'serverless-3rd-party-services',
  communications = 'serverless-communications',
  linkExtractor = 'serverless-link-extractor',
  media = 'serverless-media',
  payment = 'payment-serverless',
  search = 'serverless-search',
  services = 'serverless-services',
  tags = 'serverless-tags',
  trips = 'serverless-trips',
  users = 'serverless-users',
}
